/** @format */

import { defaultActions } from '../../core/actionsDefault';

export const reportConstants = {
    REPORT_LIST: 'report_list',
    REPORT_ITEM: 'report_item',
    REPORT_ADD: 'report_add',
    REPORT_DELETE: 'report_delete',
};

export class analyticsAccountActions extends defaultActions {}
